import { theme } from '../constants/defaults';
import htmlEscape from '../utils/htmlEscape';
import { normalizeProduct } from '../utils/product';
import searchResultsProductTemplate from './searchResultsProductTemplate';
import searchResultsCollectionTemplate from './searchResultsCollectionTemplate';
import searchResultsPageTemplate from './searchResultsPageTemplate';
import searchResultsArticleTemplate from './searchResultsArticleTemplate';
import loadingTemplate from './loadingTemplate';

function renderTypeForHeader(type) {
  if (type === 'products') {
    return theme.strings.products;
  }

  if (type === 'collections') {
    return theme.strings.collections;
  }

  if (type === 'articles') {
    return theme.strings.articles;
  }

  return theme.strings.pages;
}

function renderHeader(products, type, isLoading) {
  if (products.length === 0) {
    return '';
  }

  return `<div class="predictive-search-title">
    <h3 id="predictive-search" class="predictive-search-title__content">
      ${renderTypeForHeader(type)}
    </h3>
    <span class="predictive-search-title__loading-spinner">
      ${isLoading ? '<span class= "icon-predictive-search-spinner" ></span>' : ''}
    </span>
  </div>`;
}

function loadingState() {
  return `<div class="predictive-search">
    ${loadingTemplate()}
  </div>`;
}

function renderViewAll(searchQuery) {
  return `<button type="submit" class="predictive-search-view-all__button" tabindex="-1">
    ${theme.strings.searchFor}
    <span class="predictive-search-view-all__query"> &ldquo;
      ${htmlEscape(searchQuery)}
      &rdquo;
    </span>
  </button>`;
}

function renderProducts(products) {
  const resultsCount = products.length;
  const productsList = products.map((product, index) => {
    const productObject = normalizeProduct(product);
    return searchResultsProductTemplate(productObject, index, resultsCount);
  });

  return `
    ${productsList.join('')}`;
}

function renderArticles(articles) {
  const resultsCount = articles.length;

  const articlesList = articles.map((article, index) => {
    const articleObject = article;
    return searchResultsArticleTemplate(articleObject, index, resultsCount);
  });

  return `
    ${articlesList.join('')}`;
}

function renderPages(pages) {
  const resultsCount = pages.length;

  const pagesList = pages.map((page, index) => {
    const pageObject = page;
    return searchResultsPageTemplate(pageObject, index, resultsCount);
  });

  return `
    ${pagesList.join('')}`;
}

function renderCollection(collections) {
  const resultsCount = collections.length;

  const collectionsList = collections.map((collection, index) => {
    const collectionObject = collection;
    return searchResultsCollectionTemplate(collectionObject, index, resultsCount);
  });

  return `
    ${collectionsList.join('')}`;
}

function renderResults(products, collections, pages, articles, isLoading, searchQuery) {
  return `
  <div class="predictive-search">
  <ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
    ${renderHeader(products, 'products', isLoading)}
    ${renderProducts(products)}
    ${renderHeader(collections, 'collections', isLoading)}
    ${renderCollection(collections)}
    ${renderHeader(articles, 'articles', isLoading)}
    ${renderArticles(articles, searchQuery)}
    ${renderHeader(pages, 'pages', isLoading)}
    ${renderPages(pages, searchQuery)}
    <li id="search-all" class="predictive-search-view-all" role="option" data-search-result>
        ${renderViewAll(searchQuery)}
      </li>
    </ul>
  </div>`;
}

export const numberOfResultsTemplateFct = (resultsCount) => {
  if (resultsCount === 1) {
    return theme.strings.one_result_found;
  }

  return theme.strings.number_of_results_found.replace('[results_count]', resultsCount);
};

export const searchResultsTemplate = (data) => {
  const products = data.products || [];
  const pages = data.pages || [];
  const collections = data.collections || [];
  const articles = data.articles || [];
  const { isLoading } = data;
  const searchQuery = data.searchQuery || '';

  if (
    (isLoading && products.length === 0) ||
    (isLoading && pages.length === 0) ||
    (isLoading && collections.length === 0)
  ) {
    return loadingState();
  }

  return renderResults(products, collections, pages, articles, isLoading, searchQuery);
};

// (a11y) This function will be used by the Predictive Search Component
// to announce that it's loading results
export const loadingResultsMessageTemplateFct = () => theme.strings.loading;
